import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar";
import { StarRating } from "~/components/StarRating";
import { formatDistanceToNow } from "date-fns";

export interface StoreReviewsProps {
  id: string;
  user_id?: string;
  rating: number;
  comment: string | null;
  created_at: string;
  reviewer_display_name: string;
  reviewerImage?: string;
  reviewer_initials: string;
  className?: string;
}

export default function StoreReviews(props: StoreReviewsProps) {
  const trimmedComment = props.comment?.trim();

  return (
    <div key={props.id} className={props.className}>
      <div className="flex gap-4">
        <Avatar className="h-10 w-10 border">
          {props.reviewerImage ? (
            <AvatarImage
              src={props.reviewerImage || "/placeholder.svg"}
              alt={props.reviewer_display_name}
            />
          ) : null}
          <AvatarFallback>{props.reviewer_initials}</AvatarFallback>
        </Avatar>
        <div className="grid gap-1 w-full">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-semibold text-sm">{props.reviewer_display_name}</h3>
              <time className="text-xs text-muted-foreground">
                {formatDistanceToNow(new Date(props.created_at), {
                  addSuffix: true,
                })}
              </time>
            </div>
            <StarRating over={props.rating} />
          </div>
          {trimmedComment && (
            <p className="text-sm text-muted-foreground">{trimmedComment}</p>
          ) }
        </div>
      </div>
    </div>
  );
}
